/* Pawvana theme JS — no dependencies */
(function () {
  'use strict';

  var S = window.themeSettings || {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var format = S.moneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/<[^>]+>/g, '');
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    if (!document.body.classList.contains('anim-on')) return;
    var els = $$('.reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Paw click sparkle ---------- */
  function initPawTrail() {
    if (!S.pawTrail || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var pawSvg = '<svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor"><path d="M8.35 3.5c1.2-.2 2.34.86 2.54 2.37.2 1.5-.6 2.88-1.8 3.08-1.2.2-2.34-.86-2.54-2.37-.2-1.5.6-2.88 1.8-3.08Zm7.3 0c1.2.2 2 1.57 1.8 3.08-.2 1.5-1.34 2.57-2.54 2.37-1.2-.2-2-1.57-1.8-3.08.2-1.5 1.34-2.57 2.54-2.37ZM3.8 8.9c1.1-.42 2.42.3 2.94 1.63.52 1.32.05 2.74-1.05 3.17-1.1.42-2.42-.3-2.94-1.62-.52-1.33-.05-2.75 1.05-3.18Zm16.4 0c1.1.43 1.57 1.85 1.05 3.18-.52 1.32-1.84 2.04-2.94 1.62-1.1-.43-1.57-1.85-1.05-3.17.52-1.33 1.84-2.05 2.94-1.63ZM12 11.2c1.9 0 3.03 1.34 4.14 2.7 1.03 1.28 2.36 2.31 2.36 3.94 0 2-1.6 2.96-3.5 2.96-1.2 0-2-.6-3-.6s-1.8.6-3 .6c-1.9 0-3.5-.96-3.5-2.96 0-1.63 1.33-2.66 2.36-3.93C8.97 12.55 10.1 11.2 12 11.2Z"/></svg>';
    var last = 0;
    document.addEventListener('click', function (e) {
      if (Date.now() - last < 250) return;
      if (e.target.closest('button, a, input, select, textarea, summary, label')) return;
      last = Date.now();
      var el = document.createElement('span');
      el.className = 'paw-pop';
      el.innerHTML = pawSvg;
      el.style.left = e.clientX + 'px';
      el.style.top = e.clientY + 'px';
      document.body.appendChild(el);
      setTimeout(function () { el.remove(); }, 750);
    });
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var header = $('.site-header');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    $$('.site-nav__item--has-children').forEach(function (item) {
      var link = $('.site-nav__link', item);
      item.addEventListener('mouseenter', function () { item.classList.add('is-open'); });
      item.addEventListener('mouseleave', function () { item.classList.remove('is-open'); });
      if (link) {
        link.addEventListener('click', function (e) {
          if (window.matchMedia('(hover: none)').matches) {
            e.preventDefault();
            item.classList.toggle('is-open');
          }
        });
      }
    });

    var menu = $('.mobile-menu');
    var openBtn = $('[data-menu-open]');
    var closeEls = $$('[data-menu-close]');
    if (menu && openBtn) {
      openBtn.addEventListener('click', function () {
        menu.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
      closeEls.forEach(function (el) {
        el.addEventListener('click', function () {
          menu.classList.remove('is-open');
          document.body.style.overflow = '';
        });
      });
      $$('.mobile-menu [data-submenu-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var sub = btn.parentElement.nextElementSibling;
          if (sub) sub.classList.toggle('is-open');
        });
      });
    }

    var searchOverlay = $('.search-overlay');
    var searchOpen = $$('[data-search-open]');
    if (searchOverlay) {
      searchOpen.forEach(function (btn) {
        btn.addEventListener('click', function () {
          searchOverlay.classList.add('is-open');
          var input = $('input[type="search"]', searchOverlay);
          if (input) setTimeout(function () { input.focus(); }, 60);
        });
      });
      $$('[data-search-close]', searchOverlay).forEach(function (el) {
        el.addEventListener('click', function () { searchOverlay.classList.remove('is-open'); });
      });
      searchOverlay.addEventListener('click', function (e) {
        if (e.target === searchOverlay) searchOverlay.classList.remove('is-open');
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          searchOverlay.classList.remove('is-open');
          closeCartDrawer();
          if (menu) { menu.classList.remove('is-open'); document.body.style.overflow = ''; }
        }
      });
    }
  }

  /* ---------- Sliders (scroll-snap based) ---------- */
  function initSliders() {
    $$('[data-slider]').forEach(function (wrap) {
      var track = $('[data-slider-track]', wrap);
      var prev = $('[data-slider-prev]', wrap);
      var next = $('[data-slider-next]', wrap);
      if (!track) return;
      function step() {
        var card = track.firstElementChild;
        return card ? card.getBoundingClientRect().width + 24 : 320;
      }
      function update() {
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Cart ---------- */
  var drawer = null;

  function openCartDrawer() {
    drawer = drawer || $('.cart-drawer');
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    if (drawer) {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  function updateCartCount(count) {
    $$('.cart-count').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('has-items', count > 0);
      el.classList.remove('bump');
      void el.offsetWidth;
      if (count > 0) el.classList.add('bump');
    });
  }

  function renderCart(cart) {
    updateCartCount(cart.item_count);
    var itemsEl = $('[data-cart-items]');
    var subtotalEl = $('[data-cart-subtotal]');
    var footer = $('[data-cart-footer]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (footer) footer.style.display = cart.item_count ? '' : 'none';

    if (S.shippingBar) {
      var bar = $('[data-shipping-bar]');
      if (bar) {
        var fill = $('.shipping-bar__fill', bar);
        var label = $('[data-shipping-label]', bar);
        var remaining = S.shippingThreshold - cart.total_price;
        var pct = S.shippingThreshold > 0 ? Math.min(100, (cart.total_price / S.shippingThreshold) * 100) : 100;
        if (fill) fill.style.width = pct + '%';
        if (label) {
          label.innerHTML = remaining > 0
            ? 'You\'re <strong>' + formatMoney(remaining) + '</strong> away from FREE shipping'
            : (S.shippingUnlockedText || 'Free shipping unlocked!');
        }
      }
    }

    if (!itemsEl) return;
    if (!cart.item_count) {
      itemsEl.innerHTML = '<div class="cart-empty">' +
        '<svg class="icon" width="64" height="64" viewBox="0 0 24 24" fill="currentColor"><path d="M8.35 3.5c1.2-.2 2.34.86 2.54 2.37.2 1.5-.6 2.88-1.8 3.08-1.2.2-2.34-.86-2.54-2.37-.2-1.5.6-2.88 1.8-3.08Zm7.3 0c1.2.2 2 1.57 1.8 3.08-.2 1.5-1.34 2.57-2.54 2.37-1.2-.2-2-1.57-1.8-3.08.2-1.5 1.34-2.57 2.54-2.37ZM12 11.2c1.9 0 3.03 1.34 4.14 2.7 1.03 1.28 2.36 2.31 2.36 3.94 0 2-1.6 2.96-3.5 2.96-1.2 0-2-.6-3-.6s-1.8.6-3 .6c-1.9 0-3.5-.96-3.5-2.96 0-1.63 1.33-2.66 2.36-3.93C8.97 12.55 10.1 11.2 12 11.2Z"/></svg>' +
        '<h3>Your cart is feeling lonely</h3><p>Add something your pet will love.</p>' +
        '<a class="btn btn--primary" href="/collections/all">Start shopping</a></div>';
      return;
    }
    itemsEl.innerHTML = cart.items.map(function (item, i) {
      var img = item.image
        ? '<img class="cart-item__img" src="' + item.image.replace(/(\.[a-z]{3,4})(\?|$)/, '_160x$1$2') + '" alt="" loading="lazy">'
        : '<div class="cart-item__img"></div>';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="cart-item__variant">' + item.variant_title + '</div>' : '';
      return '<div class="cart-item" data-line="' + (i + 1) + '">' +
        img +
        '<div><div class="cart-item__title">' + item.product_title + '</div>' + variant +
        '<div class="qty-input">' +
          '<button type="button" data-qty-change="-1" aria-label="Decrease quantity"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 12h12"/></svg></button>' +
          '<input type="number" value="' + item.quantity + '" min="0" data-qty-input aria-label="Quantity">' +
          '<button type="button" data-qty-change="1" aria-label="Increase quantity"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 6v12M6 12h12"/></svg></button>' +
        '</div></div>' +
        '<div><div class="cart-item__price">' + formatMoney(item.final_line_price) + '</div>' +
        '<button type="button" class="cart-item__remove" data-remove>Remove</button></div>' +
      '</div>';
    }).join('');
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      renderCart(cart);
      return cart;
    });
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function initCart() {
    $$('[data-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (S.cartType === 'drawer') {
          e.preventDefault();
          openCartDrawer();
          fetchCart();
        }
      });
    });
    var d = $('.cart-drawer');
    if (d) {
      $$('[data-cart-close]', d).forEach(function (el) {
        el.addEventListener('click', closeCartDrawer);
      });
      d.addEventListener('click', function (e) {
        var itemEl = e.target.closest('.cart-item');
        if (!itemEl) return;
        var line = parseInt(itemEl.dataset.line, 10);
        var input = $('[data-qty-input]', itemEl);
        if (e.target.closest('[data-remove]')) { changeLine(line, 0); return; }
        var changeBtn = e.target.closest('[data-qty-change]');
        if (changeBtn && input) {
          var q = Math.max(0, parseInt(input.value || '1', 10) + parseInt(changeBtn.dataset.qtyChange, 10));
          changeLine(line, q);
        }
      });
      d.addEventListener('change', function (e) {
        var input = e.target.closest('[data-qty-input]');
        if (!input) return;
        var itemEl = input.closest('.cart-item');
        changeLine(parseInt(itemEl.dataset.line, 10), Math.max(0, parseInt(input.value || '0', 10)));
      });
    }
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { updateCartCount(c.item_count); });
  }

  function addToCart(body, button) {
    if (button) {
      button.classList.add('is-adding');
      button.dataset.originalText = button.textContent;
      button.textContent = 'Adding…';
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () {
        if (button) {
          button.textContent = 'Added ✓';
          setTimeout(function () {
            button.textContent = button.dataset.originalText;
            button.classList.remove('is-adding');
          }, 1400);
        }
        if (S.cartType === 'drawer') {
          openCartDrawer();
          return fetchCart();
        }
        window.location.href = '/cart';
      })
      .catch(function (err) {
        if (button) {
          button.textContent = (err && err.description) ? 'Unavailable' : 'Error';
          setTimeout(function () {
            button.textContent = button.dataset.originalText;
            button.classList.remove('is-adding');
          }, 1600);
        }
      });
  }

  /* Quick add buttons on cards */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      addToCart({ id: parseInt(btn.dataset.quickAdd, 10), quantity: 1 }, btn);
    });
  }

  /* ---------- Product form ---------- */
  function initProductForms() {
    $$('[data-product-form]').forEach(function (form) {
      var jsonEl = $('[data-product-json]', form.closest('section') || document);
      var product = null;
      try { product = JSON.parse(jsonEl.textContent); } catch (err) { /* no-op */ }

      var idInput = $('input[name="id"]', form);
      var atcBtn = $('[data-atc]', form);
      var priceEl = $('[data-product-price]', form.closest('section') || document);

      function currentVariant() {
        if (!product) return null;
        var selected = $$('.variant-pill input:checked', form).map(function (i) { return i.value; });
        return product.variants.find(function (v) {
          return v.options.every(function (opt, idx) { return opt === selected[idx]; });
        });
      }

      function onVariantChange() {
        var v = currentVariant();
        if (!v) {
          if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Unavailable'; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (atcBtn) {
          atcBtn.disabled = !v.available;
          atcBtn.textContent = v.available ? (atcBtn.dataset.atcText || 'Add to cart') : 'Sold out';
        }
        if (priceEl) {
          var html = '<span class="price__current">' + formatMoney(v.price) + '</span>';
          if (v.compare_at_price && v.compare_at_price > v.price) {
            html += ' <s class="price__compare">' + formatMoney(v.compare_at_price) + '</s>';
            html += ' <span class="badge badge--sale price__save">Save ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%</span>';
            priceEl.classList.add('price--sale');
          } else {
            priceEl.classList.remove('price--sale');
          }
          priceEl.innerHTML = html;
        }
        if (v.featured_image) {
          var mainImg = $('[data-gallery-main] img');
          if (mainImg) mainImg.src = v.featured_image.src;
        }
        $$('.variant-group', form).forEach(function (group, idx) {
          var label = $('[data-selected-value]', group);
          var checked = $('input:checked', group);
          if (label && checked) label.textContent = checked.value;
        });
      }

      form.addEventListener('change', function (e) {
        if (e.target.closest('.variant-pill input')) onVariantChange();
      });

      var qtyWrap = $('.qty-input', form);
      if (qtyWrap) {
        var qtyInput = $('input', qtyWrap);
        $$('button', qtyWrap).forEach(function (b) {
          b.addEventListener('click', function () {
            var delta = parseInt(b.dataset.qtyChange || '0', 10);
            qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) + delta);
          });
        });
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var qty = $('input[name="quantity"]', form);
        addToCart({
          id: parseInt(idInput.value, 10),
          quantity: qty ? Math.max(1, parseInt(qty.value, 10)) : 1
        }, atcBtn);
      });

      onVariantChange();
    });

    /* Gallery thumbs */
    $$('[data-gallery]').forEach(function (gallery) {
      var main = $('[data-gallery-main] img', gallery);
      $$('.product-gallery__thumb', gallery).forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (main && thumb.dataset.src) main.src = thumb.dataset.src;
          $$('.product-gallery__thumb', gallery).forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });

    /* Sticky mobile ATC */
    var sticky = $('.sticky-atc');
    var mainAtc = $('[data-atc]');
    if (sticky && mainAtc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0 });
      io.observe(mainAtc);
      var stickyBtn = $('[data-sticky-atc]', sticky);
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          mainAtc.closest('form').dispatchEvent(new Event('submit', { cancelable: true }));
        });
      }
    }
  }

  /* ---------- Video poster ---------- */
  function initVideo() {
    $$('[data-video-poster]').forEach(function (poster) {
      poster.addEventListener('click', function () {
        var frame = poster.parentElement;
        var url = poster.dataset.videoUrl;
        if (!url) return;
        var iframe = document.createElement('iframe');
        iframe.src = url + (url.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
        iframe.allowFullscreen = true;
        frame.appendChild(iframe);
        poster.remove();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initPawTrail();
    initHeader();
    initSliders();
    initCart();
    initQuickAdd();
    initProductForms();
    initVideo();
  });
})();
